<main class="flex flex-col items-center gap-4 px-4 py-44">
  <section class="flex flex-col md:flex-row items-center justify-center gap-4">
    <img src="/images/icons/profile/Layer-2.svg" alt="suspended" class="w-fit md:w-40" />
    <div>

      <h2 class="flex flex-col leading-none font-medium" [class]="'text-' + primaryColor "
        transloco="profile.reactivate-account.title">
        Reactiva tu cuenta
      </h2>
      <p transloco="profile.reactivate-account.subtitle" class="text-start text-base mb-2 max-w-96">
        Intenta nuevamente con tu método de pago principal o agrega uno nuevo para regularizar tu pago.
      </p>

      <p transloco="profile.reactivate-account.amount-to-pay" class="text-start text-base max-w-96">
        <span>Monto a pagar: </span> <strong>$ {{ preSuspendedData?.transactionAmount }}</strong>
      </p>
    </div>
  </section>

  <section>
    <div>
      @if (savedCards.length > 0) {
      <div>
        <h2 class="flex flex-col text-2xl mb-6 font-semibold" transloco="payment.use-saved-methods"></h2>
        <app-credit-card [savedCards]="savedCards"
          (selectedPaymentId)="onSelectedPaymentMethod($event)"></app-credit-card>
      </div>
      }

      <div class="pb-6">
        @if (savedCards.length > 0) {
        <h2 class="flex flex-col text-2xl my-6 font-semibold" transloco="payment.add-new-method"></h2>
        }
        <button type="button" (click)="showCreditCard = true"
          class="flex items-center justify-center gap-1 font-semibold w-full sm:w-fit px-6 sm:px-10 py-3 rounded-xl hover:scale-105 {{ 'text-' + primaryColor + ' border-2 border-' + primaryColor }} ">
          <span transloco="btn-vn.add-payment-method"></span>
          <img src="/images/icons/arrow-primary.svg" alt="arrow" class="w-[1.8rem] pb-1 h-fit rtl:-scale-x-100">
        </button>
      </div>
    </div>

    <app-month-select 
      [selectedDuration]="selectedDuration" 
      [currentActiveDuration]="currentActiveDuration"
      [packageData]="packageData" 
      (durationSelected)="onDurationSelected($event)" />

    <button [disabled]="selectedDuration <= 0"
      class="{{'bg-'+ primaryColor}} flex items-center gap-2 text-white px-12 py-3 rounded-xl hover:scale-105 transition-all uppercase font-semibold my-4 disabled:opacity-25"
      (click)="reactivateAccount()" transloco="btn-vn.pay">
      <img src="/images/icons/arrow-icon.svg" alt="arrow" class="w-[1.8rem] pb-1 h-fit rtl:-scale-x-100">
      Realizar pago</button>
  </section>

</main>

@if (showCreditCard) {
<app-payment-methods [isPaySuspended]="true" (paymentUpdated)="onAddCreditFromNewCard()"
  (closeModalEvent)="showCreditCard = false">
</app-payment-methods>
}